<app-category-carousel
  [title]="title"
  [limit]="limit"
></app-category-carousel>
